import React from "react";
import axiosInstance from "../../api/axiosInstance";
import { apiurl, SupportNameFn } from "../../App";
import Grid from "@material-ui/core/Grid";
import Labelbox from "../../helpers/labelbox/labelbox";
import Button from "@material-ui/core/Button";
import AddAPhotoIcon from "@material-ui/icons/AddAPhoto";
import KeyboardVoiceIcon from "@material-ui/icons/KeyboardVoice";
import Modalcomp from "../../helpers/ModalComp/Modalcomp";
import VisibilityIcon from "@material-ui/icons/Visibility";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import { notification } from "antd";
import "./TicketMaster.css";
import more from "../../Images/more.svg";
import dateformat from "dateformat";

export default class TicketView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ticket_no: "",
      status: "",
      menu: "",
      remark: "",
      ticket_date: "",
      response: [],
      playRecord: false,
      audio_url: "",
      imagedata: [],
      audio_record: [],
      ticket_time: ""
    };
  }

  componentDidMount() {
    if (this.props.editdetails) {
      let response = this.props.editdetails.comments_arr
        ? JSON.parse(this.props.editdetails.comments_arr).sort((a, b) => {
          return a > b;
        })
        : [];
      let data = dateformat(new Date(this.props.editdetails.ticket_date), "dd-mmm-yy hh:MM tt");
      let dateValue = data.split(" ")[0];
      let timeValue = data.split(" ")[1] + " " + data.split(" ")[2];
      this.setState({
        ticket_no: this.props.editdetails.ticket_no,
        status: this.getStatusByCode(this.props.editdetails.status),
        menu: SupportNameFn(this.props.editdetails.screen_name),
        remark: this.props.editdetails.remarks,
        // ticket_date: new Date(
        //   this.props.editdetails.ticket_date
        // ).toLocaleDateString("en-GB"),
        ticket_date: dateValue,
        // response: response,
        response: this.props.editdetails.admin_comments,
        imagedata: this.props.editdetails.media_filepath, //this.props.editdetails.img_arr?JSON.parse(this.props.editdetails.img_arr):[] ,
        audio_record: this.props.editdetails.audio_path, //this.props.editdetails.audio_arr?JSON.parse(this.props.editdetails.audio_arr):[],
        ticket_time: timeValue
      });
    }
  }

  getStatusByCode = (data) => {
    switch (data) {
      case "P":
        return "Pending";
      case "RO":
        return "Reopened";
      case "C":
        return "Closed";
      case "RE":
        return "Resolved";
      default:
        return "";
    }
  };

  handleClickPlayOpen = (data, type) => {
    if (type == "audio") {
      this.setState({ playRecord: true, img_url: "", audio_url: data });
    } else {
      this.setState({ playRecord: true, audio_url: "", img_url: data });
    }
  };

  extractFilenameFromURL(url) {
    var parts = url.split('/');
    var filenameWithEncodedCharacters = parts[parts.length - 1];
    var filename = decodeURIComponent(filenameWithEncodedCharacters);
    return filename
  }

  handleClickPlayclose = () => {
    this.setState({ playRecord: false, audio_url: "", img_url: "" });
  };
  render() {
    const { t } = this.props;
    return (
      <>
        <div className="ticket_view_div scroll-view" style={{ direction: (localStorage.pharmacy_language == 'ar' ? 'rtl' : '') }}>
          <Grid container spacing={2} style={{ padding: "0px 5rem 0px 5rem" }}>
            <Grid item md={4} sm={4}>
              <Labelbox
                className="label-box"
                labelname={t("tbl_head_ticket_id")}
                type="text"
                placeholder="Ticket ID"
                value={this.state.ticket_no}
                readOnly={true}
                required={false}
              />
            </Grid>
            <Grid item md={4} sm={4}>
              <Labelbox
                className="label-box"
                labelname={t("tbl_head_screen_name")}
                type="text"
                placeholder="Screen Name"
                value={this.state.menu}
                readOnly={true}
                required={false}
              />
            </Grid>
            <Grid item md={4} sm={4}>
              <Labelbox
                className="label-box"
                labelname={t("tbl_head_status")}
                type="text"
                placeholder="Status"
                value={this.state.status}
                readOnly={true}
                required={false}
              />
            </Grid>
            <Grid item md={4} sm={4}>
              <Labelbox
                className="label-box"
                labelname={t("tbl_head_ticket_date")}
                type="text"
                placeholder="Date"
                value={this.state.ticket_date}
                readOnly={true}
                required={false}
              />
            </Grid>
            <Grid item md={4} sm={4}>
              <Labelbox
                className="label-box"
                labelname={t("time")}
                type="text"
                placeholder="Time"
                value={this.state.ticket_time}
                readOnly={true}
                required={false}
              />
            </Grid>
            <Grid item md={12} sm={12}>
              <Labelbox
                className="label-box"
                labelname={t("tbl_head_issue_raised_by_vendor")}
                placeholder="Remarks"
                type="textarea"
                value={this.state.remark}
                readOnly={true}
              />
            </Grid>
            <Grid item md={6} sm={6}>
              <div className="lbltxt" style={{ textAlign: (localStorage.pharmacy_language == 'ar' ? 'right' : '') }}> {t("audio_recording")} </div>
              <div>
                {this.state.audio_record != "" && (
                  <div
                    style={{
                      display: "flex",
                      fontSize: "14px",
                      margin: "10px 0px",
                    }}
                  >
                    <div
                      style={{
                        width: "90%",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {this.extractFilenameFromURL(this.state.audio_record)}
                      {/* <audio src={obj} controls />   */}
                    </div>
                    <div style={{ width: "20%", textAlign: "center" }}>
                      <PlayArrowIcon
                        style={{
                          fill: "var(--app-theme)",
                          fontSize: "2rem",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          this.handleClickPlayOpen(
                            this.state.audio_record,
                            "audio"
                          );
                        }}
                      ></PlayArrowIcon>
                    </div>
                  </div>
                )}
                {/* {this.state.audio_record.map((obj, i) => (
                <div style={{ display: 'flex', fontSize: '14px', margin: '10px 0px' }}>
                  <div style={{ width: '90%' }}>
                    {obj['file_name']}
                  </div>
                  <div style={{ width: '20%', textAlign: 'center' }}>
                    <PlayArrowIcon style={{ fill: '#83af40', fontSize: '2rem', cursor: 'pointer' }} onClick={() => { this.handleClickPlayOpen(obj['file_path'], 'audio') }}></PlayArrowIcon>
                  </div>
                </div>
              ))} */}
              </div>
            </Grid>
            <Grid item md={6} sm={6}>
              <div className="lbltxt" style={{ textAlign: (localStorage.pharmacy_language == 'ar' ? 'right' : '') }}> {t("screenshot_or_picture")}</div>
              <div>
                {this.state.imagedata != "" && (
                  <div
                    style={{
                      display: "flex",
                      fontSize: "14px",
                      margin: "10px 0px",
                    }}
                  >
                    <div
                      style={{
                        width: "90%",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        textAlign: (localStorage.pharmacy_language == 'ar' ? 'right' : '')
                      }}
                    >
                      {this.extractFilenameFromURL(this.state.imagedata)}
                      {/* <audio src={obj} controls />   */}
                    </div>
                    <div style={{ width: "20%", textAlign: "center" }}>
                    {" "}
                    <a href={this.state.imagedata} target="_blank">
                      <img
                        src={more}
                        className="tableeye_icon"
                        style={{ fontSize: "2rem", cursor: "pointer" }}
                        // onClick={() => {
                        //   this.handleClickPlayOpen(this.state.imagedata, "image");
                        // }}
                      />
                       </a>
                      {/* <VisibilityIcon style={{ fill: 'var(--app-theme)', fontSize: '2rem', cursor: 'pointer' }} onClick={() => { this.handleClickPlayOpen(this.state.imagedata, 'image') }}></VisibilityIcon> */}
                    </div>
                  </div>
                )}

                {/* {this.state.imagedata.map((obj, i) => (
                <div style={{ display: 'flex', fontSize: '14px', margin: '10px 0px' }}>
                  <div style={{ width: '90%' }}>
                    {obj['file_name']}
                  </div>
                  <div style={{ width: '20%', textAlign: 'center' }}>
                    <VisibilityIcon style={{ fill: '#5377ee', fontSize: '2rem', cursor: 'pointer' }} onClick={() => { this.handleClickPlayOpen(obj['file_path'], 'image') }}></VisibilityIcon>
                  </div>
                </div>
              ))} */}
              </div>
            </Grid>
            <Grid item md={12} sm={12}>
              <div className="lbltxt" style={{ textAlign: (localStorage.pharmacy_language == 'ar' ? 'right' : '') }}>
                {" "}
                {t("tbl_head_Issue_addressed_by_tom")}{" "}
              </div>
              <div className="response_main_div"
                style={{
                  direction: (localStorage.pharmacy_language == 'ar' ? 'rtl' : ''),
                  display: (localStorage.pharmacy_language == 'ar' ? 'flex' : ''),
                }}>
                {this.state.response}
                {/* {this.state.response.map((obj) => (
                <div> {obj["comments"]} </div>
              ))
              } */}
              </div>
            </Grid>
          </Grid>

          <Modalcomp
            visible={this.state.playRecord}
            xswidth="xs"
            title={this.state.audio_url != "" ? t("view_recoding") : t("view_image")}
            clrchange="text_clr_change"
            closemodal={(e) => this.handleClickPlayclose(e)}
            t={t}
            i18n={this.props.i18n}
          >
            <div>
              <div style={{ textAlign: "center" }}>
                {this.state.audio_url != "" && (
                  <audio
                    controls
                    src={this.state.audio_url}
                    type="audio/mpeg"
                  ></audio>
                )}
              </div>
              <div style={{ textAlign: "center" }}>
                {this.state.audio_url == "" && (
                  <img
                    id="preimg"
                    src={this.state.img_url}
                    style={{ height: "300px", width: "auto" }}
                  />
                )}
              </div>
            </div>
          </Modalcomp>
        </div>
      </>
    );
  }
}
